import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {

  constructor() { }

  public copyToClipboard(value: string){
    const idInputConst: string = 'ClipboardService-input';  
    //
    let input: HTMLInputElement = <HTMLInputElement>document.getElementById(idInputConst);
    let body: HTMLBodyElement = document.getElementsByTagName('body')[0];
    if(input == null){
      input = <HTMLInputElement>document.createElement('INPUT');
      input.setAttribute('id', idInputConst);
      body.appendChild(input);
    }
    //
    input.setAttribute('value', value);
    input.select();
    document.execCommand('copy');
    body.removeChild(input);
  }

}
